module.exports = __webpack_public_path__ + "90c38a9f431cbad5c55862c20ee7b936.svg";